
































import { computed, defineComponent, ref } from "@vue/composition-api";
import {
  InputReviewSearch,
  Review,
  ReviewSearchResult,
  ReviewSubjectType,
} from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import InfiniteScroll from "@/components/InfiniteScroll";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import ReviewRemoveConfirm from "./ReviewRemoveConfirm.vue";
import ReviewsItem from "./ReviewsItem.vue";
import ReviewsSendController from "./ReviewsSendController.vue";

export default defineComponent({
  name: "ReviewsFullListController",
  components: {
    BaseIcon,
    CustomScroll,
    InfiniteScroll,
    ModalView,
    ReviewsItem,
    ReviewsSendController,
    ReviewRemoveConfirm,
    PageTitle,
  },
  props: {
    isAuthor: { type: Boolean, default: false },
    postId: { type: String, required: true },
    show: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { authUserStrict, isAdmin } = useAuthUser();

    const enableScroll = ref(false);
    const reviewsSearchResult = ref<ReviewSearchResult | null>(null);
    const loading = ref(false);
    const showConfirm = ref(false);
    const removeReviewId = ref("");

    const reviews = computed(() => reviewsSearchResult.value?.result);

    const addReview = (r: Review) => {
      emit("add:review", r);
      reviewsSearchResult.value?.result.unshift(r);
    };

    const removeReviewCb = (id: string) => {
      emit("remove:review", id);
      if (!reviewsSearchResult.value) return;
      reviewsSearchResult.value.result = reviewsSearchResult.value.result.filter(r => r.id !== id);
      showConfirm.value = false;
    };

    const showRemoveConfirm = (id: string) => {
      showConfirm.value = true;
      removeReviewId.value = id;
    };

    const getReviews = async (page: number = 0, replace: boolean = true) => {
      try {
        enableScroll.value = false;
        loading.value = true;
        const data: InputReviewSearch = {
          subjects: [
            {
              subjectId: props.postId,
              subjectType: ReviewSubjectType.POST,
            },
          ],
          page,
          sort: "TIME,DESC",
        };
        const response: ReviewSearchResult = await providers.ReviewProvider.find({ data });
        if (!replace && reviewsSearchResult.value) {
          response.result = [...reviewsSearchResult.value.result, ...response.result];
        }
        reviewsSearchResult.value = response;
      } finally {
        loading.value = false;
        enableScroll.value = reviewsSearchResult.value?.hasNextPage ?? false;
      }
    };
    getReviews();

    const getNextData = (cb?: Function) => {
      const page = (reviewsSearchResult.value?.page ?? 0) + 1;
      getReviews(page, false).finally(() => cb && cb());
    };

    return {
      authUserStrict,
      isAdmin,
      reviews,
      enableScroll,
      getNextData,
      addReview,
      removeReviewCb,
      removeReviewId,
      showConfirm,
      showRemoveConfirm,
    };
  },
});
